import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shared-empty-message',
  templateUrl: './shared-empty-message.component.html',
  styleUrls: ['./shared-empty-message.component.scss'],
})
export class SharedEmptyMessageComponent {
  @Input() empty_message?: string;
}
